import Yup from "../../services/Legacy/yup";

const assists_evolutions_schema = Yup.object().shape({
  intercurrence: Yup.string().required().label("intercorrência"),
  time: Yup.string().required("hora"),
});

export default assists_evolutions_schema;
